export default __webpack_public_path__ + "static/media/immaginelore3.ebcd1fe3.png";